var _CUSTOM_COD_FORM_PROVINCES = {
  data: {
    VALPARAISO: {
      ALGARROBO: true,
      CABILDO: true,
      CALERA: true,
      "CALLE LARGA": true,
      CARTAGENA: true,
      CASABLANCA: true,
      CATEMU: true,
      CONCON: true,
      "EL MELON": true,
      "EL QUISCO": true,
      "EL TABO": true,
      HIJUELAS: true,
      "LA CRUZ": true,
      "LA LIGUA": true,
      LIMACHE: true,
      LLAILLAY: true,
      "LOS ANDES": true,
      NOGALES: true,
      OLMUE: true,
      PANQUEHUE: true,
      PAPUDO: true,
      PETORCA: true,
      "PLACILLA - V DEL MAR": true,
      PUCHUNCAVI: true,
      PUTAENDO: true,
      QUILLOTA: true,
      QUILPUE: true,
      QUINTERO: true,
      RINCONADA: true,
      "SAN ANTONIO": true,
      "SAN ESTEBAN": true,
      "SAN FELIPE": true,
      "SANTA MARIA": true,
      "SANTO DOMINGO": true,
      VALPARAISO: true,
      "VILLA ALEMANA": true,
      "VINA DEL MAR": true,
      ZAPALLAR: true,
    },
    SANTIAGO: {
      ALHUE: true,
      BUIN: true,
      "CALERA DE TANGO": true,
      CERRILLOS: true,
      "CERRO NAVIA": true,
      COLINA: true,
      CONCHALI: true,
      CURACAVI: true,
      "EL BOSQUE": true,
      "EL MONTE": true,
      "ESTACION CENTRAL": true,
      HUECHURABA: true,
      INDEPENDENCIA: true,
      "ISLA DE MAIPO": true,
      "LA CISTERNA": true,
      "LA FLORIDA": true,
      "LA GRANJA": true,
      LAMPA: true,
      "LA PINTANA": true,
      "LA REINA": true,
      "LAS CONDES": true,
      "LO BARNECHEA": true,
      "LO ESPEJO": true,
      "LO PRADO": true,
      MACUL: true,
      MAIPU: true,
      "MARIA PINTO": true,
      MELIPILLA: true,
      NUNOA: true,
      "PADRE HURTADO": true,
      PAINE: true,
      "PEDRO AGUIRRE CERDA": true,
      PENAFLOR: true,
      PENALOLEN: true,
      PIRQUE: true,
      PROVIDENCIA: true,
      PUDAHUEL: true,
      "PUENTE ALTO": true,
      QUILICURA: true,
      "QUINTA NORMAL": true,
      RECOLETA: true,
      RENCA: true,
      "SAN BERNARDO": true,
      "SAN JOAQUIN": true,
      "SAN JOSE DE MAIPO": true,
      "SAN MIGUEL": true,
      "SAN PEDRO": true,
      "SAN RAMON": true,
      SANTIAGO: true,
      TALAGANTE: true,
      TILTIL: true,
      VITACURA: true,
    },
    BIOBIO: {
      "ALTO BIOBIO": true,
      ANTUCO: true,
      ARAUCO: true,
      CABRERO: true,
      CHIGUAYANTE: true,
      CONCEPCION: true,
      CONTULMO: true,
      CORONEL: true,
      CURANILAHUE: true,
      FLORIDA: true,
      HUALPEN: true,
      HUALQUI: true,
      LAJA: true,
      LEBU: true,
      "LOS ALAMOS": true,
      "LOS ANGELES": true,
      LOTA: true,
      MULCHEN: true,
      NACIMIENTO: true,
      NEGRETE: true,
      PENCO: true,
      QUILACO: true,
      QUILLECO: true,
      "SAN PEDRO DE LA PAZ": true,
      "SAN ROSENDO": true,
      "SANTA BARBARA": true,
      "SANTA JUANA": true,
      TALCAHUANO: true,
      TOME: true,
      TUCAPEL: true,
      YUMBEL: true,
    },
    ATACAMA: {
      "ALTO DEL CARMEN": true,
      CALDERA: true,
      COPIAPO: true,
      "EL SALVADOR": true,
      FREIRINA: true,
      HUASCO: true,
      "TIERRA AMARILLA": true,
      VALLENAR: true,
    },
    TARAPACÁ: {
      "ALTO HOSPICIO": true,
      CAMINA: true,
      COLCHANE: true,
      HUARA: true,
      IQUIQUE: true,
      PICA: true,
      "POZO ALMONTE": true,
      TARAPACA: true,
    },
    "LOS LAGOS": {
      ANCUD: true,
      CALBUCO: true,
      CASTRO: true,
      CHONCHI: true,
      DALCAHUE: true,
      FRESIA: true,
      FRUTILLAR: true,
      LLANQUIHUE: true,
      "LOS MUERMOS": true,
      MAULLIN: true,
      OSORNO: true,
      "PUERTO MONTT": true,
      "PUERTO VARAS": true,
      PUQUELDON: true,
      PURRANQUE: true,
      PUYEHUE: true,
      QUEMCHI: true,
      "RIO NEGRO": true,
      "SAN JUAN DE LA COSTA": true,
      "SAN PABLO": true,
    },
    COQUIMBO: {
      ANDACOLLO: true,
      CANELA: true,
      COMBARBALA: true,
      COQUIMBO: true,
      ILLAPEL: true,
      "LA HIGUERA": true,
      "LA SERENA": true,
      "LOS VILOS": true,
      "MONTE PATRIA": true,
      OVALLE: true,
      PAIGUANO: true,
      PUNITAQUI: true,
      "RIO HURTADO": true,
      SALAMANCA: true,
      VICUNA: true,
    },
    ARAUCANÍA: {
      ANGOL: true,
      CARAHUE: true,
      COLLIPULLI: true,
      CUNCO: true,
      ERCILLA: true,
      FREIRE: true,
      GALVARINO: true,
      GORBEA: true,
      LAUTARO: true,
      LONCOCHE: true,
      "NUEVA IMPERIAL": true,
      "PADRE LAS CASAS": true,
      PERQUENCO: true,
      PITRUFQUEN: true,
      PUCON: true,
      RENAICO: true,
      SAAVEDRA: true,
      TEMUCO: true,
      "TEODORO SCHMIDT": true,
      TOLTEN: true,
      TRAIGUEN: true,
      VICTORIA: true,
      VILCUN: true,
      VILLARRICA: true,
    },
    ÑUBLE: {
      BULNES: true,
      CHILLAN: true,
      "CHILLAN VIEJO": true,
      COBQUECURA: true,
      COELEMU: true,
      COIHUECO: true,
      "EL CARMEN": true,
      NINHUE: true,
      NIQUEN: true,
      PEMUCO: true,
      PINTO: true,
      PORTEZUELO: true,
      QUILLON: true,
      QUIRIHUE: true,
      RANQUIL: true,
      "SAN CARLOS": true,
      "SAN FABIAN": true,
      "SAN IGNACIO": true,
      "SAN NICOLAS": true,
      TREHUACO: true,
      YUNGAY: true,
    },
    MAULE: {
      CAUQUENES: true,
      CHANCO: true,
      COLBUN: true,
      CONSTITUCION: true,
      CUREPTO: true,
      CURICO: true,
      EMPEDRADO: true,
      HUALANE: true,
      LICANTEN: true,
      LINARES: true,
      LONGAVI: true,
      MAULE: true,
      MOLINA: true,
      PARRAL: true,
      PELARCO: true,
      PELLUHUE: true,
      PENCAHUE: true,
      RAUCO: true,
      RETIRO: true,
      "RIO CLARO": true,
      ROMERAL: true,
      "SAGRADA FAMILIA": true,
      "SAN CLEMENTE": true,
      "SAN JAVIER": true,
      "SAN RAFAEL": true,
      TALCA: true,
      TENO: true,
      VICHUQUEN: true,
      "VILLA ALEGRE": true,
      "YERBAS BUENAS": true,
    },
    "O'HIGGINS": {
      CHEPICA: true,
      CHIMBARONGO: true,
      CODEGUA: true,
      COINCO: true,
      COLTAUCO: true,
      DONIHUE: true,
      GRANEROS: true,
      "LA ESTRELLA": true,
      "LAS CABRAS": true,
      "LAS NIEVES - RANCAGU": true,
      LITUECHE: true,
      LOLOL: true,
      MACHALI: true,
      MALLOA: true,
      MARCHIHUE: true,
      MOSTAZAL: true,
      NANCAGUA: true,
      NAVIDAD: true,
      "OLIVAR - ALTO": true,
      "OLIVAR - BAJO": true,
      PALMILLA: true,
      PAREDONES: true,
      PERALILLO: true,
      PEUMO: true,
      PICHIDEGUA: true,
      PICHILEMU: true,
      PLACILLA: true,
      PUMANQUE: true,
      "QUINTA DE TILCOCO": true,
      RANCAGUA: true,
      RENGO: true,
      REQUINOA: true,
      "SAN FERNANDO": true,
      "SANTA CRUZ": true,
      "SAN VICENTE": true,
    },
    "LOS RÍOS": {
      LANCO: true,
      "LA UNION": true,
      "LOS LAGOS": true,
      MAFIL: true,
      MARIQUINA: true,
      PAILLACO: true,
      "RIO BUENO": true,
      VALDIVIA: true,
    },
  },
  startFields: function () {
    try {
      document.querySelector(
        '#_rsi-cod-form-modal-form [data-type="province_country_field"]'
      ).value = "";
      _CUSTOM_COD_FORM_PROVINCES.onProvinceChange();
      document
        .querySelector(
          '#_rsi-cod-form-modal-form [data-type="province_country_field"]'
        )
        .addEventListener(
          "change",
          _CUSTOM_COD_FORM_PROVINCES.onProvinceChange
        );
    } catch (e) {
      console.log(e);
    }
  },
  onProvinceChange: function () {
    var value = document.querySelector(
      '#_rsi-cod-form-modal-form [data-type="province_country_field"]'
    ).value;

    var html = "";

    if (!_CUSTOM_COD_FORM_PROVINCES.data[value]) {
      html += '<option value="">' + _COD_FORM_CITY_LABEL + "</option>";
      document.querySelector(
        '#_rsi-cod-form-modal-form [data-type="city_country_field"]'
      ).innerHTML = html;
      document.querySelector(
        '#_rsi-cod-form-modal-form [data-type="city_country_field"]'
      ).value = "";
      return;
    }

    html += '<option value="">' + _COD_FORM_CITY_LABEL + "</option>";

    Object.keys(_CUSTOM_COD_FORM_PROVINCES.data[value])
      .sort()
      .forEach(function (item) {
        html += '<option value="' + item + '">' + item + "</option>";
      });

    document.querySelector(
      '#_rsi-cod-form-modal-form [data-type="city_country_field"]'
    ).innerHTML = html;
    document.querySelector(
      '#_rsi-cod-form-modal-form [data-type="city_country_field"]'
    ).value = "";
  },
};

function _COD_FORM_ON_OPEN_INIT_END_DEF() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_DEF_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_DEF_COVERAGE();
    }

    var html = "";

    html += '<option value="">' + _COD_FORM_PROVINCE_LABEL + "</option>";

    Object.keys(_CUSTOM_COD_FORM_PROVINCES.data)
      .sort()
      .forEach(function (item) {
        html += '<option value="' + item + '">' + item + "</option>";
      });

    document.querySelector(
      '#_rsi-cod-form-modal-form [data-type="province_country_field"]'
    ).innerHTML = html;

    _CUSTOM_COD_FORM_PROVINCES.startFields();
  } catch (e) {
    console.log(e);
  }
}

function _COD_FORM_ON_OPEN_INIT_END_EMBEDDED() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_COVERAGE();
    }

    var onTimeout = function () {
      if (typeof _CUSTOM_COD_FORM_PROVINCES !== "undefined") {
        var html = "";

        html += '<option value="">' + _COD_FORM_PROVINCE_LABEL + "</option>";

        Object.keys(_CUSTOM_COD_FORM_PROVINCES.data)
          .sort()
          .forEach(function (item) {
            html += '<option value="' + item + '">' + item + "</option>";
          });

        document.querySelector(
          '#_rsi-cod-form-modal-form [data-type="province_country_field"]'
        ).innerHTML = html;

        _CUSTOM_COD_FORM_PROVINCES.startFields();
      } else {
        setTimeout(onTimeout, 500);
      }
    };

    setTimeout(onTimeout, 500);
  } catch (e) {
    console.log(e);
  }
}

function _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF() {
  try {
    if (
      typeof _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF_COVERAGE === "function"
    ) {
      _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF_COVERAGE();
    }

    _COD_FORM_ON_OPEN_INIT_END_EMBEDDED();
  } catch (e) {
    console.log(e);
  }
}

var _COD_FORM_CITY_LABEL = "";
var _COD_FORM_PROVINCE_LABEL = "";

function _COD_FORM_OVERWRITE_INIT() {
  _rsi.s.form.fields.items_array.forEach(function (item) {
    if (item.type == "province_country_field" || item.type == "province") {
      item.type = "province_country_field";
      item.backendFields.name = "province";
      item.backendFields.elementType = "select";

      _COD_FORM_PROVINCE_LABEL = item.n?.ph || item.label;

      item.backendFields.options = [
        {
          label: _COD_FORM_PROVINCE_LABEL,
          value: "",
        },
      ];
    } else if (item.type == "city" || item.type == "city_country_field") {
      item.type = "city_country_field";
      item.backendFields.name = "city";
      item.backendFields.elementType = "select";

      _COD_FORM_CITY_LABEL = item.n?.ph || item.label;

      let options = [
        {
          value: "",
          label: _COD_FORM_CITY_LABEL,
        },
      ];
      item.backendFields.options = options;
    }
  });

  try {
    if (typeof _COD_FORM_OVERWRITE_INIT_COVERAGE === "function") {
      if (!_COD_FORM_OVERWRITE_INIT_COVERAGE()) {
        return false;
      }
    }
  } catch (e) {
    console.log(e);
  }

  return true;
}

_COD_FORM_OVERWRITE_INIT(); 